import {
    GET_DRIVE_TRAIN,
    SET_DRIVE_TRAIN
} from "./DriveTrainType"

const getDriveTrain = (subTypeId: any) => ({
    type: GET_DRIVE_TRAIN,
    subTypeId
});

const setDriveTrain = (driveTrainList: any) => ({
    type: SET_DRIVE_TRAIN,
    driveTrainList: driveTrainList
});

export {
    getDriveTrain,
    setDriveTrain
}
